import React, { useState, useEffect } from 'react';
import './ConnectionBanner.css';

// 連線狀態橫幅：監聽 ApiClient 廣播的全域連線事件，後端連不上時顯示一致的提示與重新整理按鈕。
// 設計原則：此韌性機制在本地與正式環境完全一致，差異僅存在於 API base URL（設定層），不在行為（機制層）。
const ConnectionBanner = () => {
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    const handleUnreachable = () => setOffline(true);
    const handleReachable = () => setOffline(false);
    window.addEventListener('tech-forum:api-unreachable', handleUnreachable);
    window.addEventListener('tech-forum:api-reachable', handleReachable);
    return () => {
      window.removeEventListener('tech-forum:api-unreachable', handleUnreachable);
      window.removeEventListener('tech-forum:api-reachable', handleReachable);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="connection-banner" role="alert">
      <span className="connection-banner-text">⚠️ 無法連線到伺服器，請檢查網路連線</span>
      <button className="connection-banner-retry" onClick={() => window.location.reload()}>
        重新整理
      </button>
    </div>
  );
};

export default ConnectionBanner;
